import { Component, HostBinding, signal, ChangeDetectionStrategy} from '@angular/core';
import { Directionality } from '@angular/cdk/bidi';
import { AuthenticationComponent } from './authentication.component';
import { RegistrationComponent } from './registration.component';
import { ConfiditialPolicyComponent } from '../confiditialpolicy/confiditialpolicy.component';
import { VisitorAgreementsComponent } from '../confiditialpolicy/visitoragreements.component';


@Component({
  selector: 'frameworks',
  standalone: !true,
  templateUrl: './frameworks.component.html',
  styleUrl: './frameworks.component.scss'
})
export class FrameworksComponent {
	@HostBinding('class') classes = 'horizontal-scroll-containers';

	currentDirection: any;
	
		constructor(private directionality: Directionality) {
			this.currentDirection = this.directionality.value;
	;
		}
}
